<template>
  <div class="trail-lesson-nav">
    <button
      class="btn"
      v-for="option in options"
      :key="option.id"
      :class="{ active: value === option.id }"
      @click="$emit('input', option.id)"
    >
      {{ option.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: String
  },
  data() {
    return {
      options: [
        { id: "videos", name: "EPISÓDIOS" },
        { id: "audios", name: "ÁUDIOS" },
        { id: "pdfs", name: "MATERIAL" }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.trail-lesson-nav {
  display: flex;
  margin: 0 -20px;

  button {
    margin: 20px;
    padding: 0 0 12px;
    color: #787878;
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    box-shadow: none;
    &.active {
      color: white;
      border-bottom: 2px solid #fb263e;
      border-radius: 0;
    }
  }
}
</style>
